import { fork } from "redux-saga/effects";
import cartSaga from "./cart";
import addressSaga from "./addresses";
import rfqSaga from "./rfq";

export default function* shoppingSaga() {
  yield fork(cartSaga);
  yield fork(addressSaga);
  yield fork(rfqSaga);
}
